import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PackagesIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Packages`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 5h14l-2 9H3L1 5ZM5 3c-.46-.919.209-2 1.236-2h3.528A1.382 1.382 0 0 1 11 3M5 8.5v2M8 8.5v2M11 8.5v2"
    />
  </Icon>
);
